// src/components/portfolio/GalleryGrid.jsx
function GalleryGrid({
  images = [], // compat: array de strings
  items = [], // novo: [{ src, alt }]
  variant = "editorial", // "default" | "editorial"
  onItemClick, // (index, item) => void
}) {
  const fallbackSrc = "/images/home/prova-1.png"; // placeholder premium que já existe

  const normalized =
    items.length > 0
      ? items.map((it) => ({
          src: it?.src,
          alt: it?.alt || "Projeto Cenovix – cenografia e iluminação cênica",
        }))
      : images.map((src) => ({
          src,
          alt: "Projeto Cenovix – cenografia e iluminação cênica",
        }));

  const handleImgError = (e) => {
    // evita loop infinito caso o fallback também falhe
    if (e.currentTarget.dataset.fallbackApplied === "1") return;
    e.currentTarget.dataset.fallbackApplied = "1";
    e.currentTarget.src = fallbackSrc;
  };

  return (
    <div className={`gallery-grid gallery-grid--${variant}`}>
      {normalized.map((item, index) => (
        <figure key={`${item.src || "img"}-${index}`} className="gallery-tile">
          <button
            type="button"
            className="gallery-tile__button"
            onClick={() => onItemClick?.(index, item)}
            aria-label={`Ampliar imagem ${index + 1}`}
          >
            <img
              src={item.src || fallbackSrc}
              alt={item.alt}
              loading="lazy"
              decoding="async"
              className="gallery-tile__img"
              onError={handleImgError}
            />
          </button>
        </figure>
      ))}
    </div>
  );
}

export default GalleryGrid;
